module.exports = __webpack_public_path__ + "static/media/home.0442f5af.svg";